// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3-LsC","tab":"Tabs_tab__1Bv8h","tabActive":"Tabs_tabActive__2DWwX"};